import { defineComponent as m, useTemplateRef as l, provide as c, createBlock as p, openBlock as d, normalizeProps as u, guardReactiveProps as _, unref as o, withCtx as a, createVNode as y, renderSlot as n, normalizeClass as C } from "vue";
import r from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Drawer/drawer.js";
import w from "../../helpers/AutoWrap.vue2.js";
import R from "./DrawerMain.vue2.js";
import P from "./DrawerPanelContent.vue2.js";
import { useOUIAProps as $ } from "../../helpers/ouia.js";
const D = Symbol("DrawerContentRefKey"), I = /* @__PURE__ */ m({
  name: "PfDrawerContent",
  __name: "DrawerContent",
  props: {
    colorVariant: { default: "default" }
  },
  setup(s) {
    const t = s, f = $({ id: t.ouiaId, safe: t.ouiaSafe }), i = l("elRef");
    return c(D, i), (e, V) => (d(), p(R, u(_(o(f))), {
      default: a(() => [
        y(w, {
          ref: "elRef",
          force: "",
          component: "div",
          exclude: P,
          class: C([o(r).drawerContent, {
            [o(r).modifiers.primary]: e.colorVariant === "primary",
            [o(r).modifiers.secondary]: e.colorVariant === "secondary"
          }])
        }, {
          default: a(() => [
            n(e.$slots, "default")
          ]),
          _: 3
        }, 8, ["class"]),
        n(e.$slots, "content")
      ]),
      _: 3
    }, 16));
  }
});
export {
  D as DrawerContentRefKey,
  I as default
};
